import { CapacityState } from 'services/metrics/types'

interface CapacityCopy {
  title: string;
  variant: 'info' | 'danger';
}

export const CAPACITY_COPY: Record<CapacityState, CapacityCopy> = {
  empty: {
    title: 'Seu perfil está aparecendo para novos pacientes',
    variant: 'info',
  },
  below: {
    title: 'Seu perfil está aparecendo para novos pacientes',
    variant: 'info',
  },
  equal: {
    title: 'Seu perfil foi despriorizado para novos pacientes',
    variant: 'danger',
  },
  above: {
    title: 'Seu perfil foi despriorizado para novos pacientes',
    variant: 'danger',
  },
}

export const COUNTER_TOOLTIPS = {
  activePatients:
    'Pacientes que se consultaram com você nos últimos 30 dias e/ou possuem agendamento para as próximas semanas.',
  recurringSlots:
    'Horários recorrentes disponibilizados por você em sua agenda – exceto avulsos.',
}
